import React from "react";
import {ExternalLink} from "components/Link";
import logo888White from "apps/GB/assets/img/888logosWhite.svg";
import bwin from "apps/DE/assets/img/bwin-sponsor-dark.png";
import bwinText from "apps/DE/assets/img/bwin_text.png";
import bwinTextMobile from "apps/DE/assets/img/bwin_text_mobile.svg";
import paddypower from "apps/GB/assets/img/paddypower_dark.png";
import snickers from "apps/US/assets/img/snickers.png";
import proline from "apps/CA/assets/img/proline_dark.png";
import prolineText from "apps/CA/assets/img/proline_presented_text_dark.svg";
import baseNFLLogo from "assets/img/NFLShield.svg";
import baseNFLText from "assets/img/logo-tall-text.svg";
import baseNFLTextWhite from "assets/img/logo-tall-text-white.svg";
import baseNFLTextDE from "assets/img/logo-tall-text-de.svg";
import snickersPresented from "assets/img/mx/presented.png";

import styled from "styled-components";
import {SYNDICATE_COUNTRY, SPONSOR_LINK} from "modules/constants";
import logo from "assets/img/logo-tall.svg";

const Logo = styled.img`
	width: 26px;
`;

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	align-self: center;
	height: 100%;
`;

export const Betting888LogoWhite: React.FC = (props) => (
	<ExternalLink href="https://www.888sport.com/" {...props}>
		<Logo src={logo888White} alt="888 sport" />
	</ExternalLink>
);

export const BettingLogo: React.FC = (props) => {
	const sponsor =
		{
			DE: <img src={bwin} alt="" style={{height: "24px"}} />,
			GB: (
				<a href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
					<img src={paddypower} alt="paddypower" />
				</a>
			),
		}[SYNDICATE_COUNTRY] || null;

	if (!sponsor) {
		return null;
	}
	return <Wrapper>{sponsor}</Wrapper>;
};

const BaseImg = styled.img`
	height: 24px;
`;
export const SponsorLogo: React.FC = () => {
	const sponsor =
		{
			DE: <BaseImg src={bwin} alt="BWIN" />,
			GB: <BaseImg src={paddypower} alt="paddypower" />,
			US: <BaseImg src={snickers} alt="snickers" />,
			CA: <img src={proline} alt="proline" style={{height: "42px"}} />,
		}[SYNDICATE_COUNTRY] || null;

	if (!sponsor) {
		return null;
	}

	if (SPONSOR_LINK) {
		return (
			<Wrapper>
				<a href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
					{sponsor}
				</a>
			</Wrapper>
		);
	}
	return <Wrapper>{sponsor}</Wrapper>;
};

const FinalLogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	width: 100%;
	gap: 16px;
	flex-wrap: nowrap;
	z-index: 0;
`;

const LogoBrackets = styled.img`
	top: -37px;
	position: absolute;
`;

const Logos = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 13px;
	color: #fff;
	border-right: 1px solid currentColor;
	padding-right: 16px;
	img {
		height: 80px;
		&:last-child {
			height: 40px;
		}
	}

	&.DE {
		img {
			&:last-child {
				height: 57px;
			}
		}
	}

	&.US {
		color: #fff;
	}
`;

const CASponsor = styled.a`
	display: block;
	img {
		height: 70px;
	}
`;

const USSponsor = styled.a`
	display: block;
	img {
		height: 50px;
	}
`;

const CAFinalLogoWrapper = styled.div`
	position: absolute;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	top: 0;
	transform: translateY(40px);
	gap: 16px;
`;

export const BracketsSponsorLogo = () => {
	if (SYNDICATE_COUNTRY === "CA") {
		return (
			<FinalLogoWrapper>
				<CAFinalLogoWrapper>
					<Logos>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLText} alt="" />
					</Logos>
					<CASponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={prolineText} alt="proline" />
					</CASponsor>
				</CAFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	if (SYNDICATE_COUNTRY === "DE") {
		return (
			<FinalLogoWrapper>
				<CAFinalLogoWrapper>
					<Logos className={SYNDICATE_COUNTRY}>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLTextDE} alt="" />
					</Logos>
					<CASponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={bwinText} alt="proline" />
					</CASponsor>
				</CAFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	if (SYNDICATE_COUNTRY === "US") {
		return (
			<FinalLogoWrapper>
				<CAFinalLogoWrapper>
					<Logos className={SYNDICATE_COUNTRY}>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLTextWhite} alt="" />
					</Logos>
					<USSponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={snickersPresented} alt="snickers" />
					</USSponsor>
				</CAFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	return (
		<FinalLogoWrapper>
			<LogoBrackets src={logo} alt={"NFL logo"} />
		</FinalLogoWrapper>
	);
};

const NFLLogo = styled.div`
	position: absolute;
	margin-bottom: auto;
	width: 50px;
	height: 50px;
	left: 50%;
	bottom: 20px;
	top: 20px;
	transform: translate(-50%, 0%);
	border-radius: 50%;
	img {
		width: 100%;
		height: auto;
	}
`;

const LogosWidget = styled.div`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 4px;
	color: #000;
	border-right: 1px solid currentColor;
	padding-right: 6px;
	img {
		height: 24px;
		&:last-child {
			height: 12px;
		}
	}

	&.DE {
		img {
			height: 20px;
			&:last-child {
				height: 18px;
			}
		}
	}

	&.US {
		color: #fff;
	}
`;

const CAWidgetSponsor = styled.a`
	display: block;
	img {
		height: 30px;
	}
`;

const CAWidgetFinalLogoWrapper = styled.div`
	position: absolute;
	display: flex;
	flex-wrap: nowrap;
	top: -20px;
	transform: translateY(-100%);
	gap: 6px;
`;

export const BracketsWidgetSponsorLogo = () => {
	if (SYNDICATE_COUNTRY === "CA") {
		return (
			<FinalLogoWrapper>
				<CAWidgetFinalLogoWrapper>
					<LogosWidget>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLText} alt="" />
					</LogosWidget>
					<CAWidgetSponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={prolineText} alt="proline" />
					</CAWidgetSponsor>
				</CAWidgetFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	if (SYNDICATE_COUNTRY === "DE") {
		return (
			<FinalLogoWrapper>
				<CAWidgetFinalLogoWrapper>
					<LogosWidget className={SYNDICATE_COUNTRY}>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLTextDE} alt="" />
					</LogosWidget>
					<CAWidgetSponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={bwinTextMobile} alt="bwin" />
					</CAWidgetSponsor>
				</CAWidgetFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	if (SYNDICATE_COUNTRY === "US") {
		return (
			<FinalLogoWrapper>
				<CAWidgetFinalLogoWrapper>
					<LogosWidget className={SYNDICATE_COUNTRY}>
						<img src={baseNFLLogo} alt="" />
						<img src={baseNFLTextWhite} alt="" />
					</LogosWidget>
					<CAWidgetSponsor href={SPONSOR_LINK} target="_blank" rel="noopener noreferrer">
						<img src={snickersPresented} alt="snickers" />
					</CAWidgetSponsor>
				</CAWidgetFinalLogoWrapper>
			</FinalLogoWrapper>
		);
	}

	return (
		<NFLLogo key={"logo"}>
			<img src={logo} alt={"NFL logo"} />
		</NFLLogo>
	);
};
